import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const TONES = {
  dark: { box: "border border-hocp-border bg-hocp-bgCard", hdr: "bg-hocp-bgSubtle hover:bg-hocp-bgSubtle text-hocp-textPrimary", summary: "text-hocp-textMuted", body: "border-t border-hocp-border" },
  light: { box: "border-2 border-slate-200 bg-white", hdr: "bg-slate-50 hover:bg-slate-100 text-slate-900", summary: "text-slate-500", body: "border-t border-slate-200" },
};

/** Collapsible form section — expanded by default, open/closed state persists per session via storageKey. */
export function CollapsibleSection({ id, title, icon: Icon, children, defaultOpen = true, tone = "dark", storageKey, summary, testid }) {
  const t = TONES[tone] || TONES.dark;
  const key = storageKey ? `${storageKey}:${id}` : null;
  const tid = testid || `section-${id}`;
  const [open, setOpen] = useState(() => {
    const s = key ? sessionStorage.getItem(key) : null;
    return s == null ? defaultOpen : s === "1";
  });
  const toggle = () => setOpen((o) => { if (key) sessionStorage.setItem(key, o ? "0" : "1"); return !o; });
  return (
    <section className={`rounded-lg overflow-hidden ${t.box}`} data-testid={tid} data-state={open ? "open" : "closed"}>
      <button type="button" onClick={toggle} aria-expanded={open}
        className={`w-full flex items-center justify-between px-4 py-3 transition-colors ${t.hdr}`} data-testid={`${tid}-toggle`}>
        <span className="flex items-center gap-2 text-[13px] font-semibold">{Icon && <Icon className="w-4 h-4" />}{title}</span>
        <span className="flex items-center gap-3">
          {!open && summary && <span className={`text-[11px] truncate max-w-[240px] ${t.summary}`}>{summary}</span>}
          {open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        </span>
      </button>
      {open && <div className={`p-4 space-y-4 ${t.body}`} data-testid={`${tid}-body`}>{children}</div>}
    </section>
  );
}
